import { InferValueTypes } from '@quiz-frontend/quiz-builder/types/store-types';

import * as actions from './actions';

export interface Product {
  shortDescription: string;
  name: string;
  price: string;
  url: string;
  discountPrice: string;
  onlineOnly: boolean;
  titlePrefix: string;
  partNumber: string;
  colors: string[];
  brand: string;
  thumbnail: string;
  uuid: string;
}

export type ProductsActionTypes = ReturnType<InferValueTypes<typeof actions>>;

export enum ProductSorting {
  BEST_MATCH = '1',
  PRICE_HIGH_LOW = '2',
  PRICE_LOW_HIGH = '3',
  NEWEST = '4',
}
